import qs from "qs";
import Axios from "../utils/axiosInstance";


const fetchAnalytics = (params: {}) => {
  return Axios.get(
    `dashboard/event/details${params ? "?" + qs.stringify(params) : ""}`
  );
};

const fetchEventRevenueDetails = (params: {}) => {
  return Axios.get(
    `event/GetEventRevenueDetails${params ? "?" + qs.stringify(params) : ""}`
  );
};

const fetchGuests = (params: {}) => {
  return Axios.get(`getGuestLists${params ? "?" + qs.stringify(params) : ""}`);
};

const getEventGuestListAnalytics = (params: {}) => {
  return Axios.get(
    `getEventGuestListAnalytics${params ? "?" + qs.stringify(params) : ""}`
  );
};

const getEventGuestMatchRequest = (params: {}) => {
  return Axios.get(
    `analatics/matchRequest${params ? "?" + qs.stringify(params) : ""}`
  );
};

const getEventGuestConnectionRequests = (params: {}) => {
  return Axios.get(`analatics/connectionRequest${params ? "?" + qs.stringify(params) : ""}`);
};


const getRSVPBasedGenderRatio = (params: {}) => {
  return Axios.get(`event/analytics/get-gender-rsvp-matrix${params ? "?" + qs.stringify(params) : ""}`);
};

const getEventPendingGuestConnectionRequests = (params: {}) => {
  // eventId=2&hostId=1
  return Axios.get(`connection/get-pending-connection-details${params ? "?" + qs.stringify(params) : ""}`);
};

const getEventMatchedGuestConnectionRequests = (params: {}) => {
  // ?eventId=2&hostId=1
  return Axios.get(`connection/get-matched-connection-details${params ? "?" + qs.stringify(params) : ""}`);
};



export const AnalyticsService = {
  fetchAnalytics,
  fetchEventRevenueDetails,
  fetchGuests,
  getEventGuestListAnalytics,
  getEventGuestMatchRequest,
  getEventGuestConnectionRequests,
  getRSVPBasedGenderRatio,
  getEventPendingGuestConnectionRequests,
  getEventMatchedGuestConnectionRequests
};
